import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import {
  ICON_OPTIONS,
  findIconOptionById,
  resolveMilestoneIcon,
} from './nba.utils';
import { IconOption } from "./types";

const filterIconOptions = createFilterOptions<IconOption>();

export interface MilestoneIconProps {
  iconId?: string | null;
  fontSize?: 'small' | 'default' | 'large' | 'inherit';
  style?: React.CSSProperties;
}

export const MilestoneIcon: React.FC<MilestoneIconProps> = ({
  iconId,
  fontSize = 'small',
  style,
}) => {
  const Icon = resolveMilestoneIcon(iconId);
  if (!Icon) return null;

  return (
    <Icon
      fontSize={fontSize as any}
      style={{ marginRight: 8, color: '#FF8C69', ...style }}
    />
  );
};

export interface MilestoneIconAutocompleteProps {
  value?: string | null;
  onChange: (iconId: string | null) => void;
}

export const MilestoneIconAutocomplete: React.FC<MilestoneIconAutocompleteProps> = ({
  value,
  onChange,
}) => (
  <Autocomplete
    clearOnEscape
    disableClearable={false}
    filterOptions={(options, state) => {
      const input = state.inputValue.trim();
      if (!input) {
        return [];
      }

      return filterIconOptions(options, state).slice(0, 100);
    }}
    getOptionLabel={(option: IconOption) => option.label}
    options={ICON_OPTIONS}
    renderInput={(params) => {
      const { InputProps, ...restParams } = params;
      const SelectedIcon = findIconOptionById(value || null)?.Icon;

      return (
        <TextField
          InputProps={{
            ...InputProps,
            startAdornment: (
              <>
                {SelectedIcon && (
                  <SelectedIcon
                    fontSize="small"
                    style={{ marginRight: 4, color: '#FF8C69' }}
                  />
                )}
                {InputProps.startAdornment}
              </>
            ),
          }}
          {...restParams}
          fullWidth
          label="Icon"
          margin="normal"
        />
      );
    }}
    renderOption={(option: IconOption) => {
      const Icon = option.Icon;
      return (
        <>
          {Icon && (
            <Icon
              fontSize="small"
              style={{ marginRight: 8, color: '#FF8C69' }}
            />
          )}
          {option.label}
        </>
      );
    }}
    value={findIconOptionById(value || null)}
    onChange={(_, option: IconOption | null) =>
      onChange(option ? option.id : null)
    }
  />
);
